class Flash {
  init() {
    $('ul.flashes').on('click', '.flashes__flash', (e) => this.close(e));
    return this;
  }

  close(e) {
    const $el = $(e.currentTarget);
    this.dismiss($el);
  }

  show(html, opts) {
    const options = $.extend(
      {
        type: 'success',
        timeout: 6000,
      },
      opts
    );
    const $li = $(`<li class="flashes__flash">
      <div class="${options.type}" style="display: none">${html}</div>
    </li>`);
    $('ul.flashes').append($li);
    const $div = $li.find('div').first();

    $div.slideDown('fast');
    if (options.timeout) {
      setTimeout(() => {
        this.dismiss($li);
      }, options.timeout);
    }
    return $li;
  }

  dismiss($li) {
    const $div = $li.find('div').first();
    $div.slideUp('fast', () => {
      $li.remove();
    });
  }
}

$(() => {
  window.Flash = new Flash().init();
});
